<app-header></app-header>
<app-navbar [selected]="'ivatypes'"></app-navbar>
<app-sidebar [items]="links"></app-sidebar>